module.exports = __webpack_public_path__ + "media/images/icons/filled/account-book-e5c313da36ccc11686545b7d380f4e2f.svg";